import { useEffect, useState } from 'react'
import axios from 'axios'
import SubMenu from './SubMenu'
import { lotsColumns } from './TableColumns'
import DataTable from 'react-data-table-component';

const Lots = ({ apiEndpoint }) => {
  const [data, setData] = useState([])

  useEffect(() => {
    axios(process.env.REACT_APP_BASE_URL + apiEndpoint)
      .then(response => {
        setData(response.data.data)
      })
      .catch(err => {
        console.log(err)
      })
  }, [apiEndpoint])

  return (
    <>
      <SubMenu />
      <div className="lots-table">
        <DataTable
          className='new-table'
          columns={lotsColumns}
          data={data}
          pagination
        />
      </div>
    </>
  )
}

export default Lots
